import { computed } from 'mobx';

/**
 * 사급승강기-옵션단가 모델
 * @window w_tb_da450_option
 * @category 설치품목등록
 */
export class CompanyOptionModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(2)
   */
  spjangcd: string;

  /**
   * 년도
   *
   * **data type** varchar(4)
   */
  year: string;

  /**
   * 관급,사급구분
   *
   * **data type** varchar(1)
   */
  contflag: string;

  /**
   * 순번
   *
   * **data type** varchar(3)
   */
  seq: string;

  /**
   * 인승
   *
   * **data type** varchar(4)
   */
  nperson: string;

  /**
   * 품명코드
   *
   * **data type** varchar(50)
   */
  pcode: string;

  /**
   * 품명
   *
   * **data type** varchar(255)
   */
  pname: string;

  /**
   * 규격
   *
   * **data type** varchar(255)
   */
  psize: string;

  /**
   * 단위
   *
   * **data type** varchar(50)
   */
  punit: string;

  /**
   * 수량입력
   *
   * **data type** varchar(1)
   */
  qtyflag: string;

  /**
   * 단가
   *
   * **data type** float
   */
  uamt: string;

  /**
   * 사용유무
   *
   * **data type** varchar(1)
   */
  useyn: string;

  /**
   * 담당자
   *
   * **data type** varchar(10)
   */
  perid: string;

  /**
   * 비고
   *
   * **data type** varchar(255)
   */
  remark: string;

  /**
   * 입력자
   *
   * **data type** varchar(10)
   */
  inperid: string;

  /**
   * 입력일
   *
   * **data type** varchar(8)
   */
  indate: string;

  /**
   * 수량
   *
   * **data type** float
   */
  qty: string;

  /**
   * 속도유무
   *
   * **data type** varchar(1)
   */
  speedflag: string;

  /**
   * numberflag
   *
   * **data type** varchar(1)
   */
  numberflag: string;

  /**
   * 옵션
   *
   * **data type** varchar(1)
   */
  gubun: string;

  /**
   * 신규인지
   *
   * **data type** varchar(1)
   */
  new: string;

  constructor(data: any = {}, isNew: boolean = false) {
    this.custcd = data.custcd || '';
    this.spjangcd = data.spjangcd || '';
    this.year = data.year || '';
    this.contflag = data.contflag || '';
    this.seq = data.seq || '';
    this.nperson = data.nperson || '';
    this.pcode = data.pcode || '';
    this.pname = data.pname || '';
    this.psize = data.psize || '';
    this.punit = data.punit || '';
    this.qtyflag = data.qtyflag || '';
    this.uamt = data.uamt || '';
    this.useyn = data.useyn || '';
    this.perid = data.perid || '';
    this.remark = data.remark || '';
    this.inperid = data.inperid || '';
    this.indate = data.indate || '';
    this.qty = data.qty || '';
    this.speedflag = data.speedflag || '';
    this.numberflag = data.numberflag || '';
    this.gubun = data.gubun || '';
    this.new = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.new === '1';
  }
}
